function deepAssign() {
  // Make sure there are objects to merge
  const len = arguments.length;
  if (len < 1) return;
  // eslint-disable-next-line prefer-rest-params,consistent-return
  if (len < 2) return arguments[0];

  // Merge all objects into first
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i < len; i++) {
    // eslint-disable-next-line prefer-rest-params,no-restricted-syntax
    for (const key in arguments[i]) {
      // If it's an object, recursively merge
      // Otherwise, push to key
      if (
        // eslint-disable-next-line prefer-rest-params
        Object.prototype.toString.call(arguments[i][key]) === '[object Object]'
      ) {
        // eslint-disable-next-line prefer-rest-params
        arguments[0][key] = deepAssign(
          // eslint-disable-next-line prefer-rest-params
          arguments[0][key] || {},
          // eslint-disable-next-line prefer-rest-params
          arguments[i][key],
        );
      } else {
        // eslint-disable-next-line prefer-rest-params
        arguments[0][key] = arguments[i][key];
      }
    }
  }

  // eslint-disable-next-line prefer-rest-params,consistent-return
  return arguments[0];
}
export default deepAssign;
